<template>
  <v-dialog
    v-model="dialog"
    fullscreen
  >
      <m-search-saved-messages-ctrl
          v-on:send-and-edit="$emit('send-and-edit', $event)"
          v-on:send="$emit('send', $event)"
          v-on:close-dialog="closeDialog()"
          :organization_id="organization_id"
          :include_send="include_send"
          :include_send_and_edit="include_send_and_edit"
          v-on:click-introductions="onClickIntroductions"
      />
  </v-dialog>
</template>

<script>

export default {

    props: {
        include_send: {
            type: Boolean,
            default: () => {
                return true;
            }
        },

        include_send_and_edit: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
    },

    data() {
        return {
            dialog: false,
            organization_id: null,
        }
    },

    methods: {

        showDialog(organization_id)
        {
            this.organization_id = organization_id;
            this.dialog = true;
        },

        closeDialog()
        {
            this.dialog = false;
        },

        onClickIntroductions()
        {
            this.closeDialog();
            this.$emit('click-introductions');
        },

    },
}
</script>

<style lang="scss" scoped>
</style>